import { Fragment } from "react"
import { chain, map, capitalize } from "lodash"
import PropTypes from "prop-types"
import classNames from "classnames"
import { FIELDS } from "helpers/simulator"
import PreSelectedInput from "components/rebalance-widget/components/preselected-input"

export default function InputRows({ original, fields, isCurrentInput, onFocus, isActiveTradingDisabled, getValue, onChange, onKeyDown }) {
  const types = ["rebalanced", original && "delta"]
  return chain(types)
    .compact()
    .map((type, row) => <Fragment key={type}>
      <div className={classNames("left-label grid-item", type)}>{original ? capitalize(type) : "Trade amount"}</div>
      {map(fields, (field, col) => {
        const isInput = isCurrentInput(row, col)
        return <div key={`${type}-${field}`} className={classNames("grid-item", type, { selected: isInput, editable: !isInput })} onFocus={onFocus(row, col, field, type)}>
          <PreSelectedInput {...{ disabled: field === FIELDS.activePercentEquity && isActiveTradingDisabled, value: getValue(type, field), onChange: onChange(field, type), onKeyDown, variant: "standard", isInput }} />
        </div>
      })}
    </Fragment>,
    ).value()
}

InputRows.propTypes = {
  original: PropTypes.object,
  fields: PropTypes.array,
  isCurrentInput: PropTypes.func,
  onFocus: PropTypes.func,
  isActiveTradingDisabled: PropTypes.bool,
  getValue: PropTypes.func,
  onChange: PropTypes.func,
  onKeyDown: PropTypes.func,
}
